// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1d4L-","content":"styles_content__DNgtd","checkbox":"styles_checkbox__2Eg59","checkboxLabel":"styles_checkboxLabel__1EG1e"};